module.exports = __webpack_public_path__ + "img/book.14129fcd.svg";